import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { packingList } from '../data/party';
export function PackingList() {
  return <section id="packing" className="w-full bg-[var(--cream)] px-5 py-24" data-id="element-67" data-mp="3i2az1kht6q6q">
      <div className="mx-auto max-w-3xl" data-id="element-68" data-mp="3i219fy0oel1k">
        <h2 className="font-display mb-4 text-center text-5xl uppercase text-[var(--terracotta)] sm:text-6xl" data-id="element-69" data-mp="3n0ukljshpzyk">
          Suggested Packing List
        </h2>
        <p className="mb-12 text-center text-[var(--dusk)]" data-id="element-70" data-mp="393pjzzbjptap">
          A few ideas to help you pack for every set on the schedule.
        </p>

        <ul className="space-y-3" data-id="element-71" data-mp="2z3yllmjv6u5c">
          {packingList.map((item, i) => <motion.li key={item} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.35,
          delay: i * 0.06
        }} className="flex items-start gap-4 rounded-2xl border border-[var(--terracotta)]/10 bg-white px-6 py-4 shadow-sm" data-id="element-72" data-mp="342ide3l5305m" data-mpi={i}>
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[var(--sunset)] text-white" data-id="element-73" data-mp="vnf10rb7hra4">
                <CheckIcon className="h-3.5 w-3.5" data-id="element-74" data-mp="14ibis88zsc9l" />
              </span>
              <span className="text-[var(--dusk)]" data-id="element-75" data-mp="10gghh3r29yvt">{item}</span>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}